var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C5.77614 6 6 6.22386 6 6.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V6.5C5 6.22386 5.22386 6 5.5 6Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6C10.7761 6 11 6.22386 11 6.5V12.5C11 12.7761 10.7761 13 10.5 13C10.2239 13 10 12.7761 10 12.5V6.5C10 6.22386 10.2239 6 10.5 6Z",
    fill: "#363636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5C8.27614 6.5 8.5 6.72386 8.5 7V12C8.5 12.2761 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.2761 7.5 12V7C7.5 6.72386 7.72386 6.5 8 6.5Z",
    fill: "#363636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5C1 3.22386 1.22386 3 1.5 3H14.5C14.7761 3 15 3.22386 15 3.5C15 3.77614 14.7761 4 14.5 4H1.5C1.22386 4 1 3.77614 1 3.5Z",
    fill: "#363636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5C3.27614 4.5 3.5 4.72386 3.5 5V14H12.5V5C12.5 4.72386 12.7239 4.5 13 4.5C13.2761 4.5 13.5 4.72386 13.5 5V14.5C13.5 14.7761 13.2761 15 13 15H3C2.72386 15 2.5 14.7761 2.5 14.5V5C2.5 4.72386 2.72386 4.5 3 4.5Z",
    fill: "#363636"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.5C4.5 1.22386 4.72386 1 5 1H10.5C10.7761 1 11 1.22386 11 1.5V2C11 2.27614 10.7761 2.5 10.5 2.5C10.2239 2.5 10 2.27614 10 2H5.5C5.5 2.27614 5.27614 2.5 5 2.5C4.72386 2.5 4.5 2.27614 4.5 2V1.5Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a889e2d23ffe879d004ebef9617f4f97.svg";
export { ForwardRef as ReactComponent };